import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'displayCount'
})
export class DisplayCountPipe implements PipeTransform {
  transform(metrics: any, args?: any): any {
    for (const obj of metrics) {
      if (obj.type === 'count') {
        return obj.value.count;
      }
    }
    return null;
  }
}
